<template>
  <span>{{item.title}}</span>
</template>
<script>

export default {
  name: "vis-mnemonic-tree-item",
  props: {
    item: { type: Object, required: true },
    search: { type: String }
  }
};
</script>
